export function hasClass(el, className) {
    let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
    return reg.test(el.className)
}
  
export function addClass(el, className) {
    if (hasClass(el, className)) {
        return
    }
  
    let newClass = el.className.split(' ')
    newClass.push(className)
    el.className = newClass.join(' ')
}
// 平滑滚动
export function goTop(targetY) {
    let gotoTop = function() {
        let currentPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            currentPosition -= 10
        if (currentPosition > targetY) {
            window.scrollTo(0, currentPosition)
        } else {
            window.scrollTo(0, targetY)
            clearInterval(timer)
            timer = null
        }
    }
    let timer = setInterval(gotoTop, 1)
}
// 获取cookie
export function getCookie(name){
    let arr,
        reg=new RegExp("(^| )"+ name +"=([^;]*)(;|$)")
    if(arr=document.cookie.match(reg)){
        let str = unescape(arr[2])
        return str.substring(6)
    }else{
        return null 
    }
}
// 设置cookie
export function setCookie(name,value,time){ 
    let strsec = getSec(time) 
    let exp = new Date() 
    exp.setTime(exp.getTime() + strsec*1)
    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString() 
}
export function getSec(str){//"d7"
    let str1=str.substring(1,str.length)*1 
    let str2=str.substring(0,1)
    if (str2=="s"){return str1*1000}
    else if (str2=="h"){return str1*60*60*1000}
    else if (str2=="d"){return str1*24*60*60*1000} 
}
// 删除cookie
export function delCookie(name) { 
    let exp = new Date() 
    exp.setTime(exp.getTime() - 1) 
    let cval = getCookie(name) 
    if(cval!=null) 
    document.cookie= name + "="+cval+";expires="+exp.toGMTString() 
}
// 获取cookie 的key
export function getCookieKey(str,name){
    return JSON.parse(str).name
}

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
	if (!name) return
	if (typeof content !== 'string') {
		content = JSON.stringify(content)
	}
	window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
	if (!name) return
	return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
	if (!name) return;
	window.localStorage.removeItem(name)
}

/**
 * 拖拽的实现
*/
export function startDrag (bar, target, callback){
    if(target === null) return false
    // 窗体拖拽
    var params = {
        left: 0,
        top: 0,
        currentX: 0,
        currentY: 0,
        flag: false
    }
    //获取相关CSS属性
    var getCss = function(o,key){
        return o.currentStyle? o.currentStyle[key] : document.defaultView.getComputedStyle(o,false)[key]	
    }
    
	if(getCss(target, "left") !== "auto"){
		params.left = getCss(target, "left")
	}
	if(getCss(target, "top") !== "auto"){
		params.top = getCss(target, "top")
	}
	//o是移动对象
	bar.onmousedown = function(event){
		params.flag = true
		if(!event){
			event = window.event
			//防止IE文字选中
			bar.onselectstart = function(){
				return false
			}  
		}
		var e = event
		params.currentX = e.clientX
		params.currentY = e.clientY
	}
	document.onmouseup = function(){
		params.flag = false	
		if(getCss(target, "left") !== "auto"){
			params.left = getCss(target, "left")
		}
		if(getCss(target, "top") !== "auto"){
			params.top = getCss(target, "top")
		}
    }
	document.onmousemove = function(event){
		var e = event ? event: window.event
		if(params.flag){
			var nowX = e.clientX, nowY = e.clientY
            var disX = nowX - params.currentX, disY = nowY - params.currentY
            var maxL = document.documentElement.clientWidth - target.offsetWidth/4
            var maxT = document.documentElement.clientHeight - target.offsetHeight/4
            var iL = parseInt(params.left) + disX
            var iT = parseInt(params.top) + disY
            iL <= - target.offsetWidth*3/4 && (iL = - target.offsetWidth*3/4)
            iT <= - target.offsetWidth*3/5 && (iT = - target.offsetWidth*3/5)
            iL >= maxL && (iL = maxL)
            iT >= maxT && (iT = maxT)            
            target.style.left = iL + "px"
			target.style.top = iT  + "px"
			if (typeof callback == "function") {
				callback((parseInt(params.left) || 0) + disX, (parseInt(params.top) || 0) + disY);
			}			
			if (event.preventDefault) {
				event.preventDefault()
			}
			return false
		}
    }

}
  
  



// WEBPACK FOOTER //
// ./src/assets/js/dom.js